import { OktaAuth } from '@okta/okta-auth-js';
import envConfig from '../config/config';

export const oktaConfig = envConfig.okta;

export const issuer = `${oktaConfig.baseUrl}/oauth2/${oktaConfig.issuer}`;
export const clientId = envConfig.authorizedClientIds.accountUi;

/**
 * Origin for OAuth redirect_uri and Okta-react restoreOriginalUri. When Account UI runs in a frame,
 * prefer the top browsing context so Okta returns to the correct window. Cross-origin parents
 * cannot be read (accessing top.location throws); fall back to this frame.
 */
export function getOauthBrowsingContextOrigin() {
  try {
    if (window.top != null && window.top !== window.self) {
      return window.top.location.origin;
    }
  } catch {
    // cross-origin top
  }
  return window.location.origin;
}

export const redirectUri = `${getOauthBrowsingContextOrigin()}/callback`;

/**
 * Navigate to Okta authorize URL in the top window when embedded so OAuth is not stuck in an iframe.
 * @param {string} href
 * @param {Window} [browsingWindow] defaults to global window (override in tests / non-browser)
 */
export function assignOauthRedirectLocation(href, browsingWindow = typeof window !== 'undefined' ? window : undefined) {
  if (!browsingWindow) {
    return;
  }
  try {
    if (browsingWindow.self !== browsingWindow.top) {
      browsingWindow.top.location.assign(href);
      return;
    }
  } catch {
    // Cross-origin parent: cannot navigate top; stay in this frame.
  }
  browsingWindow.location.assign(href);
}

const oktaAuthConfiguration = {
  issuer,
  clientId,
  redirectUri,
  setLocation: assignOauthRedirectLocation,
};

export const oktaAuthJSClient = new OktaAuth(oktaAuthConfiguration);

export const REDIRECT_STORAGE_KEY = 'oidc-redirect';

export const USER_SESSION_INFO = 'user-session-info';
// Initial page with just email field
export const IDP_DISCOVERY = 'idp-discovery';
// Login + Password Page
export const PRIMARY_AUTH = 'primary-auth';
